import axios from "axios";
import { StatusCodes } from "http-status-codes";
// import * as ErrorServicio from './ErroresServicios'
import * as TipoDeError from "../isp._comun/services/Errores";
import ServiceAPI      from "../isp._comun/services/ServiceAPI";
import { keyDeErrorLogin } from "./constantesApiIdyAcceso";

export default class ServiceCerradoDeSesion extends ServiceAPI{

    
    async hacerRequerimientoAxios ({ nombreUsuario, contraseña }){
        const baseUrl = process.env.REACT_APP_API_SERVER + "/login";
        const respAxios = await axios({
            method: "post",
            url: baseUrl,
            data: {
                nombreUsuario: nombreUsuario,
                contraseña: contraseña,
            },
            headers: {
                "Content-Type": "application/json",
                // "Access-Control-Allow-Origin": "*",
                // "Content-Type": "application/x-www-form-urlencoded",
            },
            withCredentials: true,
        });
        return respAxios;
    }

    getDataDeRespuestaAxiosExitosa(respAxiosExito){
        const respuestaApi = respAxiosExito.data;

        let dataDeCreacionDeCliente;
        try {
            //parsear respuestaApi de tal manera que la data tenga el formato de exito correcto
            //Si hay error en parseo:
            // throw new Error.ErrorDeProtocoloDeServidor();
            dataDeCreacionDeCliente = respuestaApi.data;
        } catch (error) {
            throw new TipoDeError.ErrorDeProtocoloDelServidor();
        }

        return dataDeCreacionDeCliente;
    }

    lanzarErrorDeRespuestaAxiosErroneaDelComando(errorAxios){
    
        const respAxiosError = errorAxios.request;

        if (respAxiosError.status === StatusCodes.UNPROCESSABLE_ENTITY) {
            //Se parsea respuestaApiComoString 
            const respuestaApiComoString = respAxiosError.response;
            
            let respuestaApi=null;
            try {
                respuestaApi = JSON.parse(respuestaApiComoString);
                const errores = respuestaApi.data.errores;
                if(errores.length<1 || errores.length>2){
                    throw new TipoDeError("Error Parsing Login");
                }
                let usuNoValido=false, otros = 0;
                respuestaApi.data.errores.forEach((e) => {
                    if (e.key === keyDeErrorLogin.usuarioNoVal) {
                        usuNoValido=true;
                    }
                    if (e.key === keyDeErrorLogin.nombreVacio) {
                        otros++;
                    }
                    if (e.key === keyDeErrorLogin.contraVacia) {
                        otros++;
                    }
                });
                if(usuNoValido && otros>0) throw new TipoDeError("Error Parsing Login");
                if(!usuNoValido && otros===0) throw new TipoDeError("Error Parsing Login");

            } catch (error) {
                throw new TipoDeError.ErrorDeProtocoloDelServidor();
            }

            throw new TipoDeError.ListaDeErroresDelDominio({ errores: respuestaApi.data.errores });
        }

    }
}